export const businessInfo = {
  name: "Johnny's Bar Billard",
  phone: "+15141234567",
  displayPhone: "(514) 123-4567",
  address: {
    street: "11749 Boul. de Pierrefonds",
    city: "Pierrefonds",
    province: "QC",
    postalCode: "H9A 1A1",
    country: "Canada",
    full: "11749 Boul. de Pierrefonds, Pierrefonds, QC H9A 1A1, Canada"
  },
  hours: [
    { days: { en: "Mon - Thu", fr: "Lun - Jeu" }, time: "4:00 PM - 1:00 AM" },
    { days: { en: "Fri - Sat", fr: "Ven - Sam" }, time: "2:00 PM - 3:00 AM" },
    { days: { en: "Sunday", fr: "Dimanche" }, time: "2:00 PM - 12:00 AM" }
  ],
  socials: [
    { name: 'Facebook', url: 'https://www.sample.com', icon: 'FiFacebook' },
    { name: 'Instagram', url: 'https://www.sample.com', icon: 'FiInstagram' },
    { name: 'Twitter', url: 'https://www.sample.com', icon: 'FiTwitter' },
    { name: 'Youtube', url: 'https://www.sample.com', icon: 'FiYoutube' }
  ],
  googleMapsEmbedUrl: "https://maps.google.com/maps?q=11749%20Boul.%20de%20Pierrefonds,%20Pierrefonds,%20QC%20H9A%201A1&t=&z=15&ie=UTF8&iwloc=&output=embed"
};